import {
    SET_REFRESH,
    SET_REELS_CONFIG,
    SET_CURRENT_SPIN_DATA,
    RESUME_GAME,
    REVERT_GAME,
    RESUME_SPIN,
    START_SPIN,
    REEL_STOPPED,
    SPIN_COMPLETE,
    START_RESPIN,
    RESPIN_COMPLETE,
    SET_RESPIN_SUMMARY,

    SET_CURRENT_COMET_WILDS_DATA,
    COMET_WILDS_MOVEMENT_COMPLETE,

    SET_CURRENT_WIN_DATA,
    SET_CURRENT_WIN_COUNTUP,
    WIN_COUNTUP_COMPLETE,
    SET_CURRENT_WIN_ITERATION,
    WIN_ITERATION_COMPLETE,

    START_COUNTDOWN,
    START_BONUS,
    ROCKET_TAKEOFF_COMPLETE,
    SET_CURRENT_PICKS_DATA,
    START_PICK_STAGE,
    PICK_ITEM,
    SET_CURRENT_PICK_RESULT_DATA,
    ADD_EMERGENCY_FUEL,
    PICK_STAGE_COMPLETE,
    START_FREESPIN,
    FREESPIN_COMPLETE,
    SET_FREESPIN_SUMMARY,
    FREESPIN_SUMMARY_COMPLETE,

    SET_ANTICIPATION,
    SET_JACKPOT,
    START_MARS_SEQUENCE,
    PICK_LANDING_ZONE,
    SET_JACKPOT_DRAW,
    BONUS_COMPLETE,

    REEL_STOPPING,
    COLLECT_SCATTER_SYMBOL,
    COMET_FLYPAST,
    WIN_COUNTUP_STEP,
    WIN_COUNTUP_LEVEL
} from "./constants"

export function setRefresh(refresh) {
    return {
        type: SET_REFRESH,
        refresh
    }
}

export function setReelsConfig(reelsConfig) {
    return {
        type: SET_REELS_CONFIG,
        reelsConfig
    }
}

export function setCurrentSpinData(currentSpinData) {
    return {
        type: SET_CURRENT_SPIN_DATA,
        currentSpinData
    }
}

export function resumeGame() {
    return {
        type: RESUME_GAME
    }
}

export function revertGame() {
  return {
    type: REVERT_GAME
  }
}

export function resumeSpin(resumeData) {
    return {
        type: RESUME_SPIN,
        ...resumeData
    }
}

export function startSpin() {
    return {
        type: START_SPIN
    }
}

export function setReelStopped(reelStoppedIndex) {
    return {
        type: REEL_STOPPED,
        reelStoppedIndex
    }
}

export function setSpinComplete() {
    return {
        type: SPIN_COMPLETE
    }
}

export function startRespin(currentRespinIndex) {
    return {
        type: START_RESPIN,
        currentRespinIndex
    }
}

export function setRespinComplete() {
    return {
        type: RESPIN_COMPLETE
    }
}

export function setRespinSummary() {
    return {
        type: SET_RESPIN_SUMMARY
    }
}

export function setCurrentCometWildsData(currentCometWildsData) {
    return {
        type: SET_CURRENT_COMET_WILDS_DATA,
        currentCometWildsData
    }
}

export function setCometWildsMovementComplete() {
    return {
        type: COMET_WILDS_MOVEMENT_COMPLETE
    }
}

export function setCurrentWinData(currentWinData, winTotal) {
    return {
        type: SET_CURRENT_WIN_DATA,
        currentWinData,
        winTotal
    }
}

export function setCurrentWinCountUp(currentWinCountUp) {
    return {
        type: SET_CURRENT_WIN_COUNTUP,
        currentWinCountUp
    }
}

export function setWinCountUpComplete() {
    return {
        type: WIN_COUNTUP_COMPLETE
    }
}

export function setCurrentWinIteration(currentWinIteration) {
    return {
        type: SET_CURRENT_WIN_ITERATION,
        currentWinIteration
    }
}

export function setWinIterationComplete() {
    return {
        type: WIN_ITERATION_COMPLETE
    }
}

export function startCountdown() {
    return {
        type: START_COUNTDOWN
    }
}

export function startBonus() {
    return {
        type: START_BONUS
    }
}

export function setRocketTakeoffComplete() {
    return {
        type: ROCKET_TAKEOFF_COMPLETE
    }
}

export function setCurrentPicksData(currentPicksData, collectedBoosts) {
    return {
        type: SET_CURRENT_PICKS_DATA,
        currentPicksData,
        collectedBoosts
    }
}

export function startPickStage(currentPickStageIndex) {
    return {
        type: START_PICK_STAGE,
        currentPickStageIndex
    }
}

export function setPickItem(pickIndex) {
    return {
        type: PICK_ITEM,
        pickIndex
    }
}

export function setCurrentPickResultData(currentPickResultData) {
    return {
        type: SET_CURRENT_PICK_RESULT_DATA,
        currentPickResultData
    }
}

export function addEmergencyFuel() {
    return {
        type: ADD_EMERGENCY_FUEL
    }
}

export function setPickStageComplete() {
    return {
        type: PICK_STAGE_COMPLETE
    }
}

export function startFreespin(currentFreespinIndex) {
    return {
        type: START_FREESPIN,
        currentFreespinIndex
    }
}

export function setFreespinComplete() {
    return {
        type: FREESPIN_COMPLETE
    }
}

export function setFreespinSummary() {
    return {
        type: SET_FREESPIN_SUMMARY
    }
}

export function setFreespinSummaryComplete() {
    return {
        type: FREESPIN_SUMMARY_COMPLETE
    }
}

export function setJackpot(jackpot) {
    return {
        type: SET_JACKPOT,
        jackpot
    }
}

export function startMarsSequence() {
    return {
        type: START_MARS_SEQUENCE
    }
}

export function pickLandingZone() {
    return {
        type: PICK_LANDING_ZONE
    }
}

export function setJackpotDraw(jackpotDraw) {
    return {
        type: SET_JACKPOT_DRAW,
        jackpotDraw
    }
}

export function setBonusComplete() {
    return {
        type: BONUS_COMPLETE
    }
}

export function setReelStopping(reelStoppingIndex) {
    return {
        type: REEL_STOPPING,
        reelStoppingIndex
    }
}

export function setCometFlypast() {
    return {
        type: COMET_FLYPAST
    }
}

export function winCountUpStep() {
    return {
        type: WIN_COUNTUP_STEP
    }
}

export function winCountUpLevel(level) {
    return {
        type: WIN_COUNTUP_LEVEL,
        level
    }
}
